











import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Chip extends Vue {
    @Prop() denomination!: number;
    @Prop() chipCount!: bigint;

    get nextChipTopPosition() {
        return (currentIndex: number): number => -2 + currentIndex * 5;
    }
}
